// src/components/layout/Sidebar.js

// --- CORRECCIÓN AQUÍ ---
import React, { useContext, useState } from 'react'; 
import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Divider, Typography, Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/HighlightOff';
import { menuItems } from './navItems.js';
import AuthContext from '../../context/AuthContext.js';
import CloseCashDrawerModal from '../pos/CloseCashDrawerModal.js';

const drawerWidth = 240;

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, isCashSessionOpen } = useContext(AuthContext);
    const [openCloseModal, setOpenCloseModal] = useState(false); // <-- Ahora esto es válido

    const userRole = user?.role || 'Cajero';

    return (
        <>
            <Drawer
                variant="permanent"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                }}
            >
                <Toolbar>
                    <Box display="flex" alignItems="center" width="100%">
                        <img src="https://points.beer/logo_pointsbeer.png" alt="Logo" style={{ height: 40, marginRight: 10 }} />
                        <Typography variant="h6" noWrap>
                            POINTS.BEER
                        </Typography>
                    </Box>
                </Toolbar>
                <Divider />
                <List>
                    {menuItems.map((item, index) => {
                        if (!item.roles.includes(userRole)) {
                            return null;
                        }
                        if (item.isSubheader) {
                            return <Divider key={index} sx={{ my: 1 }}><Typography variant="caption">{item.text}</Typography></Divider>;
                        }
                        return (
                            <ListItem key={item.text} disablePadding>
                                <ListItemButton
                                    selected={location.pathname === item.path}
                                    onClick={() => navigate(item.path)}
                                >
                                    <ListItemIcon>{item.icon}</ListItemIcon>
                                    <ListItemText primary={item.text} />
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
                </List>
                <Divider />
                {isCashSessionOpen && (
                    <List>
                        <ListItem disablePadding>
                            <ListItemButton sx={{ backgroundColor: 'rgba(255, 0, 0, 0.1)' }} onClick={() => setOpenCloseModal(true)}>
                                <ListItemIcon><CloseIcon color="error" /></ListItemIcon>
                                <ListItemText primary="Cerrar Caja" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                )}
            </Drawer>
            <CloseCashDrawerModal open={openCloseModal} onClose={() => setOpenCloseModal(false)} />
        </>
    );
};

export default Sidebar;